module.exports = __webpack_public_path__ + "img/240.e383baf3.jpg";